import { render } from "./StockInput.vue?vue&type=template&id=6c892904"
import script from "./StockInput.vue?vue&type=script&lang=js"
export * from "./StockInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__